export default {
  fontXxl: '2rem' /* 20px */,
  fontXl: '1.8rem' /* 18px */,
  fontLg: '1.6rem' /* 16px */,
  fontMd: '1.4rem' /* 14px */,
  fontSm: '1.2rem' /* 12px */,
  fontXs: '1rem' /* 10px */,
  fontXxs: '0.9rem' /* 10px */,
};
